import React, { useState, useContext } from 'react';
import { Link } from 'react-router-dom';
import lang from '../Tools/Lang';
import MethodsTwoContext from './../Contexts/MethodsTwo';


function NavBarSite(props) {

  const methodsTwoContext = useContext(MethodsTwoContext);
  let userName = methodsTwoContext.authorizationInfo.state.username;

  console.log(methodsTwoContext.authorizationInfo.state.accessToken, methodsTwoContext.authorizationInfo.state.name, userName, 'ssssdddd');
  const [text, setText] = useState('');
  let activeHandler = e => {
    if (text === '') {
      setText('active');
    }
    else {
      setText('');
    }
  }
  return (
    <>
        {/* <div class="nav nav_extra">
          <nav class="nav_section container">
            <div class="hamburger_menu">
              <i id="hamburger_menu" onClick={activeHandler} aria-hidden="true" class="fas fa-bars"></i>
            </div>
          </nav>
        </div>




      <div id="header_menu_toggle" class={`header_menu_toggle container ${text}`} >
        <ul>
          <li class="no-action">
            <form action="/search" class="search_box">
              <input type="text" name="search" placeholder="دنبال چی میگردی ؟" />
            </form>
          </li>
          <li>
            <Link to="/" onClick={activeHandler} >صفحه اصلی</Link>
          </li>
          <li>
            <Link to="/login" onClick={activeHandler} >ورود</Link>
          </li>
          <li>
            <Link to="/register?plan=0" onClick={activeHandler} >عضویت</Link>
          </li>
          <li>
            <Link to="/projects" onClick={activeHandler} >پروژه ها</Link>
          </li> */}
          {/* <li>
            <Link to="/discuss" onClick={activeHandler} >بحث و گفتگو&zwnj;ها</Link>
          </li> */}
          {/* <li>
            <Link to="/series" onClick={activeHandler} >محصولات</Link>
          </li> */}
          {/* <li>
            <Link to="/lessons" onClick={activeHandler} >جدیدترین محصولات</Link>
          </li> */}
          {/* <li>
            <Link to="/articles" onClick={activeHandler} >مقالات</Link>
          </li>
          {

            userName === 'zamanianstar@gmail.com' ? (
              <li>
                <Link to="/events" onClick={activeHandler} >یادآوری</Link>
              </li>
            ) : (<></>)
          }
          <li>
            <Link to="/Contribution" onClick={activeHandler} >استخدام</Link>
          </li>
          <li>
            <Link to="/contact-us" onClick={activeHandler} >ارتباط با ما</Link>
          </li>
        </ul>
      </div> */}




      <div class="header_menu">
        <ul class="container">
          <li>
            <Link to="/">{lang.getStr('main_page')}</Link>
          </li>
          <li>
            <Link to="/projects">{lang.getStr('projects')}</Link>
          </li>
          {/* <li class="has-submenu">
            <a href="#">{lang.getStr('products')}</a>
            <ul class="submenu">
              <li class="submenu-item">
                <span class="icon"></span>
                <Link to="/series">{lang.getStr('all_products')}</Link>
              </li>
              <li class="submenu-item">
                <span class="icon"></span>
                <Link to="/lessons">{lang.getStr('newest')}</Link>
              </li>
              <li class="submenu-item">
                <span class="icon"></span>
                <Link to="/Events"> {lang.getStr('reminder')}</Link>
              </li>
            </ul>
          </li> */}
        <li class="has-submenu">
            <a href="#">{lang.getStr('services')}</a>
            <ul class="submenu">
              <li class="submenu-item">
                <span class="icon"></span>
                <Link to="/webDesign">{lang.getStr('webDesign')}</Link>
              </li>
              <li class="submenu-item">
                <span class="icon"></span>
                <Link to="/webApp">{lang.getStr('webApp')}</Link>
              </li>
              <li class="submenu-item">
                <span class="icon"></span>
                <Link to="/mobileApp"> {lang.getStr('mobileApp')}</Link>
              </li>
            </ul>
          </li>
          {/* <li>
            <Link to="/discuss">{lang.getStr('discussion')}</Link>
          </li> */}
          <li>
            <Link to="/articles">{lang.getStr('articles')}</Link>
          </li>
          <li>
            <Link to="/about-us">{lang.getStr('about_us')}</Link>
          </li> 
          {

            userName === 'zamanianstar@gmail.com' ? (
              <li class="submenu-item">
                <Link to="/Events"> {lang.getStr('reminder')}</Link>
              </li>
            ) : (<></>)
          }
          {/* <li>
            <Link to="/podcast">{lang.getStr('bitkala_cast')}</Link>
          </li> */}
          {/* <li>
            <a href="/user/panel/resume">رزومه&zwnj;ساز</a>
          </li> */}
        </ul>
      </div>

    </>
  )
}

export default NavBarSite;